import { RuleNamespace } from './rule-namespace';

export class RuleDao
{
    ruleNamespace: RuleNamespace;
    ruleId: string;
    condition: string;
    action: string;
    priority: number;
    description: string;
}